import { icon } from "@msuite/ui/icons";
import type { MenuItemType } from "@msuite/ui/menu";
import { resetQueryCache } from "@msuite/ui/query";
import { toast } from "@msuite/ui/toast";
import { authClient } from "@/api/auth";
import { useAuth } from "./use-auth";

export function useNavigationOrganizations() {
	/** Hooks */
	const { user, organizations, organization } = useAuth();

	/** Functions */
	/**
	 * Switch the active organisation and start the app over in it. The query cache is keyed
	 * without the organisation and the sync client is built per session, so an in-place switch
	 * would keep serving the previous organisation's rows; the cache is emptied and the page
	 * reloaded on "/", which no organisation's permissions refuse — the same reset the dev
	 * sign-in-as picker does.
	 */
	async function handleOnSetOrganizationActive(organizationId: string) {
		if (organizationId === organization.id) return;
		const { error } = await authClient.organization.setActive({ organizationId });
		if (error) {
			toast.error(error.message ?? "Error");
			return;
		}
		resetQueryCache();
		window.location.assign("/");
	}

	function createOrganizationNavigationItems() {
		if (!user) return [] as MenuItemType[];
		const items: MenuItemType[] =
			organizations.data?.map((org) => ({
				icon: icon("Building"),
				label: org.name,
				onClick: () => handleOnSetOrganizationActive(org.id),
			})) || [];
		return items;
	}

	return { createOrganizationNavigationItems };
}
